// extracted by mini-css-extract-plugin
export default {"AdSlotOffsite":"bgh_a bhe_bi"};